import FirebaseContext, { withFirebase } from "./context";
import Firebase from "./Firebase";
export default Firebase;
export { FirebaseContext, withFirebase };
